import { IApplicationState } from '../../types/redux';

export function selectLocationId(state: IApplicationState): number | undefined {
  return state.geo.location?.id;
}
